import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiPlus, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "What Is a Real Estate Appraisal, and How Does It Work?",
    a: "A real estate appraisal is an impartial, expert assessment of a property's market value—conducted by a certified appraiser. The process involves analyzing recent sales, market trends, the property's condition, and location. The final report helps buyers, sellers, lenders, and investors make confident decisions about loans, purchases, or sales."
  },
  {
    q: "What Factors Affect My Property's Appraised Value?",
    a: "Appraisers consider: location and neighborhood trends, property size, condition, and age, upgrades and unique features, comparable recent sales (comps), and current local real estate market conditions. Each of these elements helps ensure the appraisal reflects true, fair market value."
  },
  {
    q: "What Should I Expect During the Appraisal Process?",
    a: "1. Initial Consultation — discuss your needs with a certified appraiser.\n2. Data & Document Collection — provide floor plans, previous appraisals, and records.\n3. On-Site Visit — the appraiser inspects property features, condition, and improvements.\n4. Market Analysis & Report — clear, unbiased appraisal report delivered with quick turnaround."
  },
  {
    q: "What Types of Appraisals Do You Offer?",
    a: "• Residential Appraisals — for single-family homes, condos, and estates.\n• Commercial Appraisals — for offices, retail, industrial, and multifamily properties.\n• Investment Analysis — tailored reports for investors evaluating risk, return, and market position."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="section-padding bg-white">
      <div className="container-custom max-w-4xl">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold"></div>
            <span className="text-gold font-semibold uppercase tracking-wider text-sm">Frequently Asked Questions</span>
            <div className="w-8 h-[2px] bg-gold"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">Our Most Common Appraisal Questions</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                className="w-full text-left px-6 py-5 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors"
              >
                <span className="font-serif font-bold text-lg text-navy pr-8">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === idx ? 'bg-gold text-white' : 'bg-gray-100 text-navy'}`}>
                  <SafeIcon icon={openIndex === idx ? FiMinus : FiPlus} />
                </div>
              </button>
              
              <AnimatePresence>
                {openIndex === idx && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-6 pt-2 text-muted whitespace-pre-line leading-relaxed border-t border-gray-100">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;